"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactLoadingSkeleton = _interopRequireWildcard(require("react-loading-skeleton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var SkeletonLoader = function SkeletonLoader(props) {
  var classes = props.classes,
      className = props.className,
      count = props.count,
      width = props.width,
      height = props.height,
      duration = props.duration,
      circle = props.circle,
      disableAnimation = props.disableAnimation,
      color = props.color;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("prmbl-skeletonLoader", (0, _defineProperty2.default)({}, classes.disableAnimation, disableAnimation), className)
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.SkeletonTheme, {
    color: color ? color : "rgba(0,0,0,.10)",
    highlightColor: disableAnimation ? "transparent" : "rgba(0,0,0,.10)"
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
    count: count,
    width: width,
    height: height,
    duration: duration,
    circle: circle
  })));
};

SkeletonLoader.propTypes = {
  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Classes to apply to the root
   */
  className: _propTypes.default.string,

  /**
   * The number of lines to show
   */
  count: _propTypes.default.number,

  /**
   * Width of the skeleton. Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Height of the skeleton. Useful when you don't want to adapt the skeleton to a text element but for instance a card. Also needed for the prop circle.
   */
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Duration is how long it takes do one cycle of the skeleton animation.
   */
  duration: _propTypes.default.number,

  /**
   * Prop for making the skeleton look like a circle, for when you are creating a user card with a profile picture for instance.
   * Height is needed if you use this prop.
   */
  circle: _propTypes.default.bool,

  /**
   * Disables the animation of the prop
   */
  disableAnimation: _propTypes.default.bool,

  /**
   * Removes the automatic transparency and inversion of the background color in favor of a hard background color.
   */
  color: _propTypes.default.string
};

var _default = (0, _styles2.withStyles)(_styles.styles)(SkeletonLoader);

exports.default = _default;